import React from 'react'
import { Load } from '../../shared'

export const Placeholder = (props) => {
  return (
    <>
      <div className="card" style={{ height: 'calc(100vh - 186px)' }}>
        <div className="card-body card-body-fill" style={{ paddingTop: 70 }}>
          <Load height={49} />
        </div>
      </div>
    </>
  )
}
